import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Image, Button, Alert, Modal, Form } from 'react-bootstrap';
import './Contacts.css';
import { showContacts, updateContact, delete_contact } from '../../../helpers';
import Spinner from '../../../components/Spinner';

interface Contact {
    id: string;
    name: string;
    mobile_no: string;
    group_name: string;
    profileUrl: string;
}
interface TestContactProps {
    onSuccess?: (msg: string) => void;
    onError?: (msg: string) => void;
}

const Test_Contact: React.FC<TestContactProps> = ({ onSuccess, onError }) => {

    // const Test_Contact: React.FC = () => {
    const [contacts, setContacts] = useState<Contact[]>([]);
    const [filteredContacts, setFilteredContacts] = useState<Contact[]>([]);
    const [groups, setGroups] = useState<string[]>([]);
    const [groupCounts, setGroupCounts] = useState<{ [key: string]: number }>({});
    const [activeGroup, setActiveGroup] = useState<string>('All');

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const [selectedContact, setSelectedContact] = useState<Contact | null>(null);
    const [editedContact, setEditedContact] = useState<Contact | null>(null);

    const [showViewModal, setShowViewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);

    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [searchTerm, setSearchTerm] = useState('');

    const [alertMsg, setAlertMsg] = useState<string | null>(null);
    const [alertVariant, setAlertVariant] = useState<'success' | 'danger' | 'primary'>('success');


    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12;
    // const [company, setCompanyid] = useState('0');

    // console.log(company_id);

    useEffect(() => {
        const init = async () => {
            try {
                const company_id =
                    JSON.parse(sessionStorage.getItem('shreyu_user') || '{}')?.user?.company_id;

                if (!company_id) throw new Error('Company ID missing');

                await fetchContacts(company_id);
            } catch (err) {
                console.error(err);
                setError('Failed to load company info');
                setLoading(false);
            }
        };

        init();
    }, []);


    // console.log(company);

    const fetchContacts = async (companyId: string) => {
        try {
            const response = await showContacts();

            const normalized: Contact[] = response.data.map((c: any) => ({
                id: c.contact_id,
                name: c.name || c.contact_name,
                mobile_no: c.mobile_no,
                group_name: c.group_name || 'Ungrouped',
                profileUrl: c.profile
                    ? `https://api.skynyx.ai/file_storage/${companyId}/contacts/${c.profile}`
                    : null,
            }));

            setContacts(normalized);
            setFilteredContacts(normalized);

            const uniqueGroups = Array.from(new Set(normalized.map(c => c.group_name)));
            setGroups(uniqueGroups);

            const counts: any = { All: normalized.length };
            normalized.forEach(c => {
                counts[c.group_name] = (counts[c.group_name] || 0) + 1;
            });
            setGroupCounts(counts);

            setLoading(false);
        } catch {
            setError('Failed to fetch contacts');
            setLoading(false);
        }
    };
    const handleDelete = async (contact: Contact) => {
        if (!window.confirm('Are you sure you want to delete this user?')) return;

        try {
            const company_id =
                JSON.parse(sessionStorage.getItem('shreyu_user') || '{}')?.user?.company_id;

            await delete_contact(contact.id);

            await fetchContacts(company_id); // IMPORTANT

            setAlertVariant('danger');
            setAlertMsg('Deleted successfully');

            setTimeout(() => setAlertMsg(null), 3000); // auto hide
        } catch (err) {
            console.error(err);
            setAlertVariant('danger');
            setAlertMsg('Delete failed');
        }
    };

    const filterByGroup = (group: string) => {
        setActiveGroup(group);
        setSearchTerm('');
        setCurrentPage(1);

        if (group === 'All') setFilteredContacts(contacts);
        else setFilteredContacts(contacts.filter(c => c.group_name === group));
    };
    const handleSearch = (value: string) => {
        setSearchTerm(value);
        setCurrentPage(1);

        let baseList = activeGroup === 'All'
            ? contacts
            : contacts.filter(c => c.group_name === activeGroup);

        const result = baseList.filter(c =>
            c.name.toLowerCase().includes(value.toLowerCase()) ||
            c.mobile_no.includes(value)
        );

        setFilteredContacts(result);
    };


    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentContacts = filteredContacts.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filteredContacts.length / itemsPerPage);

    const handleView = (contact: Contact) => {
        setSelectedContact(contact);
        setShowViewModal(true);
    };

    const handleEdit = (contact: Contact) => {
        setEditedContact({ ...contact });
        setPreviewUrl(null);
        setShowEditModal(true);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!editedContact) return;
        setEditedContact({ ...editedContact, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files?.length) return;
        const reader = new FileReader();
        reader.onloadend = () => setPreviewUrl(reader.result as string);
        reader.readAsDataURL(e.target.files[0]);
    };

    const handleSaveEdit = async () => {
        if (!editedContact) return;

        const payload = {
            contact_name: editedContact.name,
            mobile_no: editedContact.mobile_no,
            group_name: editedContact.group_name,
            profile: previewUrl || editedContact.profileUrl,
        };

        await updateContact(editedContact.id, payload);

        setContacts(prev => prev.map(c => (c.id === editedContact.id ? editedContact : c)));
        setFilteredContacts(prev => prev.map(c => (c.id === editedContact.id ? editedContact : c)));

        setShowEditModal(false);
    };
    { loading && <Spinner /> }
    { error && <Alert variant="danger">{error}</Alert> }
    return (
        <>
            {alertMsg && (
                <Alert
                    variant={alertVariant}
                    onClose={() => setAlertMsg(null)}
                    dismissible
                    className="mb-3"
                >
                    {alertMsg}
                </Alert>
            )}

            <Row>
                {/* LEFT SIDEBAR */}
                <Col md={2}>
                    <Card>
                        <Card.Body>
                            <h6>Groups</h6>

                            <div className={`group-item ${activeGroup === 'All' ? 'active' : ''}`} onClick={() => filterByGroup('All')}>
                                All <span>{groupCounts['All'] || 0}</span>
                            </div>


                            {groups.map(grp => (
                                // <div key={grp} className={`group-item ${activeGroup === grp ? 'active' : ''}`} onClick={() => filterByGroup(grp)}>
                                //     {grp} <span>{groupCounts[grp] || 0}</span>
                                // </div>
                                <div
                                key={grp}
                                className={`group-item ${activeGroup === grp ? 'active' : ''}`}
                                onClick={() => filterByGroup(grp)}
                            >
                                {grp.length > 15 ? grp.substring(0, 15) + '...' : grp}
                                <span>{groupCounts[grp] || 0}</span>
                            </div>
                            ))}
                            
                        </Card.Body>
                    </Card>
                </Col>

                {/* RIGHT CONTENT */}
                <Col md={10}>
                    <Card>
                        <Card.Body>

                            <Form.Control
                                type="text"
                                placeholder="Search contacts..."
                                className="mb-3"
                                value={searchTerm}
                                onChange={(e) => handleSearch(e.target.value)}
                            />

                            <Row>
                                {currentContacts.map(contact => (
                                    <Col md={3} key={contact.id} className="">
                                        <Card className="text-center shadow-sm">
                                            <Card.Body>
                                                <Image src={contact.profileUrl} roundedCircle width={80} height={80} className="mb-2" />
                                                <h6>{contact.name}</h6>
                                                <small>{contact.mobile_no}</small>

                                                <div className="mt-2 d-flex justify-content-center gap-3" >
                                                    <i className="bi bi-eye-fill text-info" style={{ cursor: 'pointer' }} onClick={() => handleView(contact)} />
                                                    <i className="bi bi-pencil-square text-warning" style={{ cursor: 'pointer' }} onClick={() => handleEdit(contact)} />
                                                    <i className="bi bi-trash-fill text-danger" style={{ cursor: 'pointer' }} onClick={() => handleDelete(contact)} />
                                                    <i className="bi bi-chat-dots-fill text-success" style={{ cursor: 'pointer' }}
                                                        // onClick={() => { localStorage.setItem('chatContactId', String(contact.id)); window.location.href = '/apps/chat'; }}
                                                        onClick={() => { localStorage.setItem('chatContactId', String(contact.id)); window.location.href = '/apps/chat'; }}
                                                    />
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>

                            {/* PAGINATION */}
                            {totalPages > 1 && (
                                <div className="d-flex justify-content-center align-items-center gap-3 mt-3">

                                    <Button
                                        size="sm"
                                        disabled={currentPage === 1}
                                        onClick={() => setCurrentPage(p => p - 1)}
                                    >
                                        Prev
                                    </Button>

                                    <span style={{ fontWeight: 600 }}>
                                        Page {currentPage} of {totalPages}
                                    </span>

                                    <Button
                                        size="sm"
                                        disabled={currentPage === totalPages}
                                        onClick={() => setCurrentPage(p => p + 1)}
                                    >
                                        Next
                                    </Button>

                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>

                {/* VIEW MODAL */}
                <Modal show={showViewModal} onHide={() => setShowViewModal(false)}>
                    <Modal.Header closeButton><Modal.Title>Contact Details</Modal.Title></Modal.Header>
                    <Modal.Body className="text-center">
                        {selectedContact && (
                            <>
                                <Image src={selectedContact.profileUrl} roundedCircle width={120} height={120} className="mb-3" />
                                <h5>{selectedContact.name}</h5>
                                <p>{selectedContact.mobile_no}</p>
                                <p>{selectedContact.group_name}</p>
                            </>
                        )}
                    </Modal.Body>
                </Modal>

                {/* EDIT MODAL */}
                <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                    <Modal.Header style={{ background: 'linear-gradient(135deg, #0eb7eb, #167491)' }} >
                        <Modal.Title className='text-white'>Edit Contact</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {editedContact && (
                            <Form>
                                <Form.Group className="mb-3 text-center">
                                    <Image
                                        src={previewUrl || editedContact.profileUrl}
                                        roundedCircle
                                        width={120}
                                        height={120}
                                        className="mb-3"
                                        onError={(e) => {
                                            (e.target as HTMLImageElement).src = 'https://via.placeholder.com/120'; // fallback image
                                        }}
                                    />
                                    <Form.Control
                                        type="file"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                        className="mb-3"
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={editedContact.name}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Mobile Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="mobile_no"
                                        value={editedContact.mobile_no}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Group Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="group_name"
                                        value={editedContact.group_name}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Form>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="success" onClick={handleSaveEdit}>
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Row>
        </>
    );
};

export default Test_Contact;
